import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import useDeepEqualMemoization from '../../hooks/useDeepEqualMemoization'
import * as appModalActions from '../../store/appModal/actions'

export default function appModalTrigger(Component) {
  function AppModalTrigger(props) {
    const {
      disabled = false,
      modalProps,
      type,
      ...restProps
    } = props

    const dispatch = useDispatch()
    const memoizedProps = useDeepEqualMemoization(modalProps || {})

    const openModal = useCallback((e) => {
      e.preventDefault()
      if (disabled) {
        return
      }
      dispatch(appModalActions.openModal(type, memoizedProps))
    }, [disabled, dispatch, memoizedProps, type])

    return (
      <Component onClick={openModal} disabled={disabled} {...restProps} />
    )
  }

  AppModalTrigger.propTypes = {
    disabled: PropTypes.bool,
    modalProps: PropTypes.object,
    type: PropTypes.string.isRequired,
  }

  return AppModalTrigger
}
